<template>
  <v-reports
  v-if="access.report_employee"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  ></v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
export default {
  name: "ReportsByEmployee",
  mixins: [Currency],
  data: () => ({
    headers: [
      { text: "Name", value: "name", available: true, disabled: true },
      { text: "Gross sales", value: "gross_sales", available: true },
      { text: "Refunds", value: "refunds", available: true },
      { text: "Discounts", value: "discount", available: true },
      { text: "Net sales", value: "net_sales", available: true },
      { text: "Receipts", value: "receipts", available: true },
      { text: "Average sale", value: "average_sale", available: true },
      // {text: 'Customers signed up', value: 'customers_signed_up', available: true}
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    current_currency: 1,
    access: null,
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.params = params;
      this.data_loading = true;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var employees = this.$communicator.then(
        this,
        await this.$communicator("sales_by_employee", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      for (let i = 0; i < employees.data.length; i++) {
        employees.data[i].average_sale = Math.round(
          employees.data[i].average_sale
        ).toLocaleString();
        employees.data[i].discount = (
          Math.round(employees.data[i].discount * current_currency) /
          current_currency
        ).toLocaleString();
        employees.data[i].gross_sales = (
          Math.round(employees.data[i].gross_sales * current_currency) /
          current_currency
        ).toLocaleString();
        employees.data[i].net_sales = (
          Math.round(employees.data[i].net_sales * current_currency) /
          current_currency
        ).toLocaleString();
        employees.data[i].refunds = (
          Math.round(employees.data[i].refunds * current_currency) /
          current_currency
        ).toLocaleString();
      }
      this.data = employees.data;
      this.data_loading = false;
      this.numPages = employees.page;
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      { text: this.$t(`name`), value: "name", available: true, disabled: true },
      { text: this.$t(`gross_sales`), value: "gross_sales", available: true },
      { text: this.$t(`refunds`), value: "refunds", available: true },
      { text: this.$t(`discounts`), value: "discount", available: true },
      { text: this.$t(`net_sales`), value: "net_sales", available: true },
      { text: this.$t(`receipts`), value: "receipts", available: true },
      { text: this.$t(`average_sale`), value: "average_sale", available: true },
      // {text: 'Customers signed up', value: 'customers_signed_up', available: true}
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
